import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SocialMediaContent } from '../models';
import { UserService } from '@oa/shared-core';

@Injectable()
export class SocialMediaContentService {
  constructor(private http: HttpClient, readonly userService: UserService) { }


  getAllContent(): Observable<SocialMediaContent[]> {
    return this.http.get<SocialMediaContent[]>('content/posts');
  }
  addContent(content: SocialMediaContent) {
    if (this.userService.isAdmin) {
      return this.http.post('content/posts', content);
    }
  }
  deleteContent(content: SocialMediaContent) {
    if (this.userService.isAdmin) {
      return this.http.delete(`content/posts/${content.id}`);
    }
  }
}
